import styled from "styled-components/macro";

export const Sidebar = styled.div`
  margin: 0;
  padding: 1rem;
  width: 300px;
  background-color: #ffffff;
  position: fixed;
  max-height: 82vh;
  overflow: auto;

  input,
  select {
    height: 2rem;
    font-size: 0.9rem;
  }

  @media screen and (max-width: 700px) {
    width: 100%;
    height: auto;
    position: relative;
    display: none;
  }
`;

export const Content = styled.div`
  margin-left: 300px;
  padding: 1rem;

  .openFilters {
    display: none;
  }

  @media screen and (max-width: 700px) {
    margin-left: 0;
    .openFilters {
      display: inline;
      margin-right: 0.5rem;
    }
  }
`;

export const CardHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
